import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rules-and-restriction',
  templateUrl: './rules-and-restriction.component.html',
  styleUrls: ['./rules-and-restriction.component.css']
})
export class RulesAndRestrictionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
